webpackJsonp([34,36],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SWITCH_EFFECT; });
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lazyLoading__ = __webpack_require__(70);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// import tables from './tables'
// import components from './components'
// import uifeatures from './uifeatures'

// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [
  // {
  //   name: 'Dashboard',
  //   path: '/dashboard',
  //   meta: {
  //     icon: 'fa-tachometer',
  //     link: 'dashboard/index.vue'
  //   },
  //   component: lazyLoading('dashboard', true)
  // },
  {
    name: 'FileUpload',
    path: '/upload',
    meta: {
      icon: 'fa-cloud-upload',
      link: 'admin/Upload.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('upload', true)
  }, {
    name: 'UploadedFiles',
    path: '/myfiles',
    meta: {
      icon: 'fa-folder-open',
      link: 'admin/MyFiles.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('myfiles', true)
  }, {
    name: 'User Admin',
    path: '/userhandler',
    meta: {
      icon: 'fa-user',
      link: 'admin/HandleUsers.vue',
      auth: 'admin'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('userhandler', true)
    // {
    //   name: 'Axios',
    //   path: '/axiosDemo',
    //   meta: {
    //     auth: true,
    //     icon: 'fa-rocket',
    //     link: 'axios/index.vue'
    //   },
    //   component: lazyLoading('axios', true)
    // },
    // charts,
    // uifeatures,
    // components
    // tables
  }]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  mutations: mutations
};

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(114)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(162),
  /* scopeId */
  "data-v-6dd74de2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(115)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  "data-v-5d96b83a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(148),
  /* scopeId */
  "data-v-13405f3d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(152),
  /* scopeId */
  "data-v-34685c23",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(102)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(116)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  "data-v-89fe38c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(62);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(121)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(170),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./DMCA.vue": [
		19
	],
	"./FileEdit.vue": [
		20
	],
	"./FileInfo.vue": [
		21
	],
	"./Home.vue": [
		22
	],
	"./TOC.vue": [
		23
	],
	"./URLShortner.vue": [
		24
	],
	"./admin/HandleUsers.vue": [
		25
	],
	"./admin/MyFiles.vue": [
		26
	],
	"./admin/Upload.vue": [
		27
	],
	"./auth/Login.vue": [
		28
	],
	"./axios/index.vue": [
		185,
		3
	],
	"./charts/Chartist.vue": [
		186,
		16
	],
	"./charts/Chartjs.vue": [
		187,
		2
	],
	"./charts/Peity.vue": [
		188,
		28
	],
	"./charts/Plotly.vue": [
		189,
		22
	],
	"./charts/index.vue": [
		190,
		32
	],
	"./components/BackToTop.vue": [
		191,
		31
	],
	"./components/Brace.vue": [
		192,
		0
	],
	"./components/Collapse.vue": [
		193,
		26
	],
	"./components/Datepicker.vue": [
		194,
		6
	],
	"./components/Default.vue": [
		195,
		30
	],
	"./components/Emoji.vue": [
		196,
		14
	],
	"./components/Lory.vue": [
		197,
		5
	],
	"./components/Message.vue": [
		198,
		21
	],
	"./components/Modal.vue": [
		199,
		4
	],
	"./components/Notification.vue": [
		200,
		20
	],
	"./components/ProgressBar.vue": [
		201,
		25
	],
	"./components/ProgressTracker.vue": [
		202,
		11
	],
	"./components/Quill.vue": [
		203,
		15
	],
	"./components/Rating.vue": [
		204,
		10
	],
	"./components/Slider.vue": [
		205,
		19
	],
	"./components/Switch.vue": [
		206,
		18
	],
	"./components/Tabs.vue": [
		207,
		7
	],
	"./components/Tooltip.vue": [
		208,
		24
	],
	"./components/index.vue": [
		209,
		33
	],
	"./components/modals/CardModal.vue": [
		182,
		9
	],
	"./components/modals/ImageModal.vue": [
		183,
		13
	],
	"./components/modals/Modal.vue": [
		184,
		12
	],
	"./dashboard/index.vue": [
		210,
		1
	],
	"./tables/Basic.vue": [
		211,
		27
	],
	"./ui/Buttons.vue": [
		212,
		23
	],
	"./ui/Form.vue": [
		213,
		8
	],
	"./ui/Icons.vue": [
		214,
		17
	],
	"./ui/Typography.vue": [
		215,
		29
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 34;


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nprogress__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websanova_vue_upload__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websanova_vue_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__websanova_vue_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_store_mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_numeral__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_meta__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_meta__);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = 'https://www.filesbeast.net/';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_meta___default.a, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
  tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__websanova_vue_auth___default.a, {
  auth: {
    request: function request(req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
    },

    response: function response(res) {
      var headers = this.options.http._getHeaders.call(this, res);
      var token = headers.Authorization || headers.authorization;
      if (token !== null && token !== undefined) {
        token = token.split(/Bearer:?\s?/i);

        return token[token.length > 1 ? 1 : 0].trim();
      }

      return false;
    }
  },
  http: __webpack_require__(35),
  router: __webpack_require__(36),
  loginData: { url: '/api/v1/login', fetchUser: true },
  refreshData: { enabled: false },
  fetchData: { url: '/api/v1/user' },
  rolesVar: 'role'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_nprogress___default.a);
// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__websanova_vue_upload___default.a, {
  http: function http(data) {
    this.Vue.axios.post(data.url, data.body, {
      progress: data.progress
    }).then(function (response) {
      if (response.data.success) {
        data.success(response);
      } else {
        data.error(response);
      }
    });
  },
  maxSizePerFile: 1024 * 1024 * 5000,
  extensions: ['jpeg', 'jpg', 'png', 'gif', 'zip', 'tar.xz', 'tar.gz', 'rar', 'apk', 'exe', 'msi', 'tar.md5', 'tar', 'tar.bz2', 'md5', 'gz', 'xz', 'bz2'],
  multiple: true,
  async: true,
  maxFilesInProgress: 5
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(174));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number');
  }

  var exponent = void 0;
  var unit = void 0;
  var neg = num < 0;
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
  num = (num / Math.pow(1024, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? '-' : '') + num + ' ' + unit;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('uppercase', function (value) {
  if (!value) {
    return '';
  }

  return value.toString().toUpperCase();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatNumber', function (value) {
  return __WEBPACK_IMPORTED_MODULE_12_numeral___default()(value).format('0,0'); // displaying other groupings/separators is possible, look at the docs
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalize', function (value) {
  if (!value) {
    return '';
  }

  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]);

var nprogress = new __WEBPACK_IMPORTED_MODULE_4_vue_nprogress___default.a({ parent: '.nprogress-container' });

var state = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state;


__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].beforeEach(function (route, redirect, next) {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_11_vuex_store_mutation_types__["a" /* TOGGLE_SIDEBAR */], false);
  }
  next();
});

Object.keys(__WEBPACK_IMPORTED_MODULE_9__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_9__filters__[key]);
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_6__App_vue___default.a));



/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RightSidebar__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RightSidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RightSidebar__);
/* unused harmony reexport RightSidebar */











/***/ }),
/* 64 */
/***/ (function(module, exports) {



/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(16);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  hashbang: false,
  linkActiveClass: 'is-active',
  mode: 'history',
  base: __dirname,
  routes: [{
    name: 'Home',
    path: '/',
    component: __webpack_require__(22)
  }, {
    name: 'Login',
    path: '/login',
    component: __webpack_require__(28)
  }, {
    name: 'Upload',
    path: '/upload',
    component: __webpack_require__(27),
    meta: { auth: true }
  }, {
    name: 'MyFiles',
    path: '/myfiles',
    component: __webpack_require__(26),
    meta: { auth: true }
  }, {
    name: 'Add Users',
    path: '/userhandler',
    component: __webpack_require__(25),
    meta: { auth: 'admin' }
  }, {
    name: 'File Info',
    path: '/file/:fileid',
    component: __webpack_require__(21)
  }, {
    name: 'File Edit',
    path: '/edit/:fileid',
    component: __webpack_require__(20)
  }, {
    name: 'URL Shortner',
    path: '/shorturl',
    component: __webpack_require__(24)
  }, {
    name: 'DMCA',
    path: '/dmca',
    component: __webpack_require__(19)
  }, {
    name: 'TOC',
    path: '/toc',
    component: __webpack_require__(23)
  }].concat(_toConsumableArray(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: '*',
    redirect: '/'
  }])
});

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });


var toggleSidebar = function toggleSidebar(_ref, opened) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], opened);
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], device);
};

var expandMenu = function expandMenu(_ref3, menuItem) {
  var commit = _ref3.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref4, effectItem) {
  var commit = _ref4.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], effectItem);
  }
};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pkg", function() { return pkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};



/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_app__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_menu__ = __webpack_require__(16);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_5__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_6__modules_menu__["a" /* default */]
  },
  state: {
    pkg: __WEBPACK_IMPORTED_MODULE_2_package___default.a
  },
  mutations: {}
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(4);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], function (state, opened) {
  if (state.device.isMobile) {
    state.sidebar.opened = opened;
  } else {
    state.sidebar.opened = true;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  mutations: mutations
};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(34)("./" + name + (index ? '/index' : '') + '.vue');
  };
};

/***/ }),
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout___ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1_components_layout___["c" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["d" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar(!isMobile);
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }),

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['toggleDevice', 'toggleSidebar'])
};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  }
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__["a" /* default */]
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: {
    codelink: function codelink() {
      if (this.$route.meta && this.$route.meta.link) {
        return 'https://github.com/vue-bulma/vue-admin/blob/master/client/views/' + this.$route.meta.link;
      } else {
        return null;
      }
    },
    name: function name() {
      return this.$route.name;
    }
  },

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {

  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__["a" /* default */]
  },

  props: {
    show: Boolean
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    pkginfo: 'pkg',
    sidebar: 'sidebar'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['toggleSidebar']), {
    logout: function logout() {
      this.$auth.logout({
        redirect: 'Home',
        makeRequest: false
        // params: {},
        // success: function () {},
        // error: function () {},
        // etc...
      });
    }
  })
};

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_collapse__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_collapse__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Collapse: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_collapse__["Item"]
  },
  props: {
    show: Boolean
  },

  data: function data() {
    return {
      popularfiles: []
    };
  },
  created: function created() {
    var _this = this;

    // fetch popular files
    this.$http({
      url: '/api/v1/search/popular',
      transformResponse: [function (data) {
        return JSON.parse(data.replace(/T00:00:00Z/g, ''));
      }]
    }).then(function (response) {
      var _popularfiles;

      (_popularfiles = _this.popularfiles).push.apply(_popularfiles, _toConsumableArray(response.data.files));
    }).catch(function (error) {
      console.log(error);
    });
  }
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
  },

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      isReady: false
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    menu: 'menuitems'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    checkAuth: function checkAuth(meta) {
      if (meta.hasOwnProperty('auth')) {
        var authrole = meta['auth'];
        return this.$auth.check(authrole);
      }

      return true;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      file: {
        name: '',
        tags: '',
        randname: ''
      }
    };
  },

  methods: {
    updateFileInfo: function updateFileInfo() {
      this.$http.post('/api/v1/admin/file/edit', this.file).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$http({
      url: '/api/v1/file/' + this.$route.params.fileid
    }).then(function (response) {
      _this.file = [];
      _this.file = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  }
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_card__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_collapse__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_adsense__ = __webpack_require__(126);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import VueDisqus from 'vue-disqus'


/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    BaseCard: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_card__["a" /* BaseCard */],
    CardFooterItem: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_card__["b" /* CardFooterItem */],
    // VueDisqus,
    Collapse: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_collapse__["Item"],
    VueAdsense: __WEBPACK_IMPORTED_MODULE_2_vue_adsense__["a" /* default */]
  },
  data: function data() {
    return {
      file: {
        name: ''
      },
      popularfiles: [],
      recentfiles: []
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$http({
      url: '/api/v1/file/' + this.$route.params.fileid,
      transformResponse: [function (data) {
        return JSON.parse(data.replace(/T00:00:00Z/g, ''));
      }]
    }).then(function (response) {
      _this.file = response.data;

      if (typeof response.data.success !== 'undefined') {
        _this.$router.push('/');
      }
    }).catch(function (error) {
      console.log(error);
    });

    // fetch popular files
    this.$http({
      url: '/api/v1/search/popular',
      transformResponse: [function (data) {
        return JSON.parse(data.replace(/T00:00:00Z/g, ''));
      }]
    }).then(function (response) {
      _this.popularfiles = response.data.files;
    }).catch(function (error) {
      console.log(error);
    });

    // recent files
    this.$http({
      url: '/api/v1/page/1',
      transformResponse: [function (data) {
        return JSON.parse(data.replace(/T00:00:00Z/g, ''));
      }]
    }).then(function (response) {
      _this.recentfiles = response.data.files;
    }).catch(function (error) {
      console.log(error);
    });
  },

  computed: {
    capstitle: function capstitle() {
      // `this` points to the vm instance
      var tooltip = '&nbsp; <img class="trustimage" src="/assets/img/trust.png" alt="trust" title="All files are first tested by our administrators and only then uploaded. The files are completely safe and secure to download and use.">';
      return this.file.name.toUpperCase() + tooltip;
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Download ' + this.file.name,
      // override the parent template and just use the above title only
      titleTemplate: null,
      meta: [{ name: 'keywords', content: this.file.tags }, { name: 'description', content: 'You can download ' + this.file.name + ' from FilesBeast for free. No speed limits.' }, { name: 'twitter:card', content: 'Summary' }, { name: 'twitter:description', content: 'You can download ' + this.file.name + ' from FilesBeast. No speed limits.' }, { name: 'twitter:title', content: 'Download ' + this.file.name + ' from FilesBeast' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'FilesBeast | Fast Free Downloads' }, { property: 'og:site_name', content: 'FilesBeast | Fast Free Downloads' }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: 'https://filesbeast.net' + window.location.pathname }]
    };
  },

  methods: {
    prettyBytes: function prettyBytes(num) {
      // jacked from: https://github.com/sindresorhus/pretty-bytes

      if (typeof num !== 'number') {
        throw new TypeError('Expected a number');
      }

      var exponent = void 0;
      var unit = void 0;
      var neg = num < 0;
      var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      if (neg) {
        num = -num;
      }

      if (num < 1) {
        return (neg ? '-' : '') + num + ' B';
      }

      exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
      num = (num / Math.pow(1024, exponent)).toFixed(2) * 1;
      unit = units[exponent];

      return (neg ? '-' : '') + num + ' ' + unit;
    },
    getDescription: function getDescription(file) {
      var desc = '<div class="LOADINGBGWRAPPER LOADINGBGCONTENT2"></div>' + '<br/><div class="LOADINGBGWRAPPER LOADINGBGCONTENT4"></div>' + '<br/><div class="LOADINGBGWRAPPER LOADINGBGCONTENT3"></div>';
      if (file.size !== undefined) {
        desc = '<span class="filedata"><strong>Size</strong><br/>' + this.prettyBytes(parseInt(file.size)) + '</span>';
        desc += '<br/><span class="filedata"><strong>Downloads</strong><br/>' + file.downloads + '</span>';
        desc += '<br/><span class="filedata"><strong>MD5 Hash</strong><br/><span class="filecode"> ' + file.hash + '</span></span>';
        desc += '<br/><span class="filedata"><strong>Upload Date</strong><br/>' + file.created_on + '</span>';
      }
      return desc;
    },
    copyUrl: function copyUrl() {
      var copyText = 'https://flb.st/' + this.$route.params.fileid;
      var mark = void 0,
          selection = void 0,
          range = void 0;
      try {
        var _range = document.createRange();
        var _selection = document.getSelection();

        mark = document.createElement('span');
        mark.textContent = copyText;
        // reset user styles for span element
        mark.style.all = 'unset';
        // prevents scrolling to the end of the page
        mark.style.position = 'fixed';
        mark.style.top = 0;
        mark.style.clip = 'rect(0, 0, 0, 0)';
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = 'pre';
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = 'text';
        mark.style.MozUserSelect = 'text';
        mark.style.msUserSelect = 'text';
        mark.style.userSelect = 'text';

        document.body.appendChild(mark);

        _range.selectNode(mark);
        _selection.addRange(_range);

        var successful = document.execCommand('copy');
        if (!successful) {
          throw new Error('copy command was unsuccessful');
        }
      } catch (err) {
        try {
          window.clipboardData.setData('text', copyText);
        } catch (err) {
          console.log('unable to copy');
        }
      } finally {
        if (selection) {
          if (typeof selection.removeRange === 'function') {
            selection.removeRange(range);
          } else {
            selection.removeAllRanges();
          }
        }
        var d = document.getElementsByClassName('short-link');
        d[0].className += ' copying';
        setTimeout(function () {
          d[0].className = 'short-link card-footer-item';
        }, 500);
        mark.blur();
        if (mark) {
          document.body.removeChild(mark);
        }
      }
    }
  }
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_jump__ = __webpack_require__(32);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var timeout = null;
/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    BackToTop: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_jump__["a" /* BackToTop */]
  },
  metaInfo: {
    title: 'FilesBeast',
    // override the parent template and just use the above title only
    titleTemplate: null,
    meta: [{ name: 'description', content: 'FilesBeast is a completely free file sharing service. Download files free, securely, anonymously, without limits.' }, { name: 'keywords', content: 'file downloads, file hosting, file sharing, fast file downloads' }]
  },
  data: function data() {
    return {
      uploadedfiles: [],
      search: '',
      searchedfiles: [],
      popularfiles: [],
      pagetop: 0,
      next: 0,
      numpages: 0,
      currentElem: false
    };
  },

  methods: {
    searchFiles: function searchFiles() {
      clearTimeout(timeout);
      var self = this;
      // Make a new timeout set to go off in 800ms
      timeout = setTimeout(function () {
        if (self.search !== '') {
          self.$http({
            url: '/api/v1/search/' + self.search
          }).then(function (response) {
            var _self$searchedfiles;

            self.searchedfiles = [];
            (_self$searchedfiles = self.searchedfiles).push.apply(_self$searchedfiles, _toConsumableArray(response.data.files));
          }).catch(function (error) {
            console.log(error);
          });
        }
      }, 300);
    },
    fetchPage: function fetchPage(pagenum, event) {
      var _this = this;

      if (event) {
        if (this.currentElem) {
          this.currentElem.className = 'pagination-next ';
        }
        this.currentElem = event.currentTarget;
        this.currentElem.className += 'is-active-page';
      }
      this.$http({
        url: '/api/v1/page/' + pagenum,
        transformResponse: [function (data) {
          return JSON.parse(data.replace(/T00:00:00Z/g, ''));
        }]
      }).then(function (response) {
        _this.uploadedfiles = response.data.files;
        if (pagenum === 1) {
          _this.pagetop = response.data.rowcnt;
          // calculate number of pages
          _this.numpages = Math.ceil(_this.pagetop / 10);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    var _this2 = this;

    // fetch latest files data
    this.fetchPage(1, false);

    // fetch popular files
    this.$http({
      url: '/api/v1/search/popular',
      transformResponse: [function (data) {
        return JSON.parse(data.replace(/T00:00:00Z/g, ''));
      }]
    }).then(function (response) {
      var _popularfiles;

      (_popularfiles = _this2.popularfiles).push.apply(_popularfiles, _toConsumableArray(response.data.files));
    }).catch(function (error) {
      console.log(error);
    });
  }
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      shorturls: [],
      url: ''
    };
  },

  methods: {
    shortenURL: function shortenURL() {
      var _this = this;

      this.$http.post('/api/v1/short', this.url).then(function (response) {
        if (response.data.success) {
          _this.shorturls.push(response.data.url);
        }
      });
    },
    copyUrl: function copyUrl(cururl) {
      var copyText = cururl;
      var mark = null;
      var selection = null;
      var range = null;
      try {
        var _range = document.createRange();
        var _selection = document.getSelection();

        mark = document.createElement('span');
        mark.textContent = copyText;
        // reset user styles for span element
        mark.style.all = 'unset';
        // prevents scrolling to the end of the page
        mark.style.position = 'fixed';
        mark.style.top = 0;
        mark.style.clip = 'rect(0, 0, 0, 0)';
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = 'pre';
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = 'text';
        mark.style.MozUserSelect = 'text';
        mark.style.msUserSelect = 'text';
        mark.style.userSelect = 'text';

        document.body.appendChild(mark);

        _range.selectNode(mark);
        _selection.addRange(_range);

        var successful = document.execCommand('copy');
        if (!successful) {
          throw new Error('copy command was unsuccessful');
        }
      } catch (err) {
        try {
          window.clipboardData.setData('text', copyText);
        } catch (err) {
          console.log('unable to copy');
        }
      } finally {
        if (selection) {
          if (typeof selection.removeRange === 'function') {
            selection.removeRange(range);
          } else {
            selection.removeAllRanges();
          }
        }
        var d = document.getElementsByClassName('short-link');
        d[0].className += ' copying';
        setTimeout(function () {
          d[0].className = 'short-link';
        }, 500);
        mark.blur();
        if (mark) {
          document.body.removeChild(mark);
        }
      }
    }
  }
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      users: [],
      data: {
        body: {
          username: '',
          email: '',
          password: ''
        }
      }
    };
  },

  methods: {
    deleteUser: function deleteUser(id) {
      this.$http({
        url: '/api/v1/user/delete/' + id
      }).then(function (response) {
        if (response.status === 200 && response.data.success === true) {
          document.getElementById(id).remove();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    adduser: function adduser() {
      var _this = this;

      this.$http.post('/api/v1/user/add', this.data.body).then(function (response) {
        if (response.data.success) {
          _this.$http({
            url: '/api/v1/user/fetch/all'
          }).then(function (response) {
            var _users;

            _this.users = [];
            (_users = _this.users).push.apply(_users, _toConsumableArray(response.data));
          }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    this.$http({
      url: '/api/v1/user/fetch/all'
    }).then(function (response) {
      var _users2;

      _this2.users = [];
      (_users2 = _this2.users).push.apply(_users2, _toConsumableArray(response.data));
    }).catch(function (error) {
      console.log(error);
    });
  }
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      uploadedfiles: []
    };
  },

  methods: {
    deleteFile: function deleteFile(id) {
      this.$http({
        url: '/api/v1/delete/' + id
      }).then(function (response) {
        if (response.status === 200 && response.data.success === true) {
          document.getElementById(id).remove();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    navigateTo: function navigateTo(path) {
      this.$router.push(path);
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$http({
      url: '/api/v1/files',
      transformResponse: [function (data) {
        return JSON.parse(data.replace(/T00:00:00Z/g, ''));
      }]
    }).then(function (response) {
      var _uploadedfiles;

      (_uploadedfiles = _this.uploadedfiles).push.apply(_uploadedfiles, _toConsumableArray(response.data.files));
    }).catch(function (error) {
      console.log(error);
    });
  },
  mounted: function mounted() {}
};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_progress_bar__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_progress_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_progress_bar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_progress_bar___default.a
  },
  created: function created() {
    this.$upload.new('file-upload', {
      url: '/api/v1/upload',
      async: true,
      maxFiles: 20,
      multiple: true,
      onStart: function onStart() {
        //          this.$toggle.show('product:media:uploads')
      },
      onSuccess: function onSuccess(res) {},
      onEnd: function onEnd() {
        // lol
      }
    });
  },
  mounted: function mounted() {
    this.$upload.reset('file-upload', {
      dropzoneId: 'file-upload-dropzone'
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$upload.reset('file-upload', {
      dropzoneId: null
    });
  },

  methods: {
    copyUrl: function copyUrl(text) {
      console.log(text);
      var copyText = 'https://flb.st/' + text;
      console.log(copyText);
      var mark = void 0,
          selection = void 0,
          range = void 0;
      try {
        var _range = document.createRange();
        var _selection = document.getSelection();

        mark = document.createElement('span');
        mark.textContent = copyText;
        // reset user styles for span element
        mark.style.all = 'unset';
        // prevents scrolling to the end of the page
        mark.style.position = 'fixed';
        mark.style.top = 0;
        mark.style.clip = 'rect(0, 0, 0, 0)';
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = 'pre';
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = 'text';
        mark.style.MozUserSelect = 'text';
        mark.style.msUserSelect = 'text';
        mark.style.userSelect = 'text';

        document.body.appendChild(mark);

        _range.selectNode(mark);
        _selection.addRange(_range);

        var successful = document.execCommand('copy');
        if (!successful) {
          throw new Error('copy command was unsuccessful');
        }
      } catch (err) {
        try {
          window.clipboardData.setData('text', copyText);
        } catch (err) {
          console.log('unable to copy');
        }
      } finally {
        if (selection) {
          if (typeof selection.removeRange === 'function') {
            selection.removeRange(range);
          } else {
            selection.removeAllRanges();
          }
        }
        var d = document.getElementsByClassName('short-link');
        d[0].className += ' copying';
        setTimeout(function () {
          d[0].className = 'short-link';
        }, 500);
        mark.blur();
        if (mark) {
          document.body.removeChild(mark);
        }
      }
    }
  }
};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      data: {
        body: {
          username: null,
          password: null
        },
        rememberMe: false
      },
      error: null
    };
  },
  mounted: function mounted() {
    if (this.$auth.redirect()) {
      console.log('Redirect from: ' + this.$auth.redirect().from.name);
    }
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },

  methods: {
    login: function login() {
      var redirect = this.$auth.redirect();
      this.$auth.login({
        headers: {
          'Content-Type': 'application/json'
        },
        data: this.data.body,
        rememberMe: this.data.rememberMe,
        redirect: { name: redirect ? redirect.from.name : 'Upload' },
        success: function success(res) {
          // do stuff
        },
        error: function error(err) {
          if (err.response) {
            // The request was made, but the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(err.response.status)
            // console.log(err.response.data)
            // console.log(err.response.headers)
            console.log(err.response.data);
            this.error = err.response.data;
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message);
          }
        }
      });
    }
  }
  // filters: {
  //   json: function (value) {
  //     console.log(value)
  //     return value
  //   }
  // }

};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    adClient: {
      type: String,
      required: true
    },
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      required: false,
      default: 'auto'
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block'
    },
    fullWidthResponse: {
      type: String,
      required: false,
      default: "true"
    }
  },
  mounted: function mounted() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
};

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    title: {
      type: String
    },
    icon: String,
    content: String,
    transition: {
      type: String,
      default: "fade"
    }
  },
  methods: {
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  },

  computed: {
    enterClass: function enterClass() {
      return this.transition + "In";
    },
    leaveClass: function leaveClass() {
      return this.transition + "Out";
    }
  }
};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);



var CardFooterItem = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('card-footer-item', {
  props: {
    element: {
      type: String,
      default: 'a',
      validator: function validator(value) {
        return ['a', 'link', 'div'].includes(value);
      }
    },
    href: String,
    to: Object
  },

  render: function render(createElement) {
    var element = this.element,
        href = this.href,
        to = this.to;

    var dataObj = { 'class': 'card-footer-item' };

    if (element === 'a' && href) {
      dataObj.attrs = { href: href };
    } else if (element === 'link' && to) {
      dataObj.attrs = { to: to };
    }

    if (this.$slots.default) {
      return createElement(element === 'link' ? 'router-link' : element, dataObj, this.$slots.default);
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = CardFooterItem;

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    isFullwidth: Boolean,
    accordion: Boolean
  },

  computed: {
    $collapseItems: function $collapseItems() {
      return this.$children.filter(function (child) {
        return child._isCollapseItem;
      });
    }
  },

  methods: {
    openByIndex: function openByIndex(index) {
      if (this.accordion) {
        this.$collapseItems.forEach(function (item, i) {
          if (i !== index) {
            item.isActived = false;
          }
        });
      }
    }
  }

};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    selected: Boolean,
    title: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isActived: this.selected
    };
  },
  created: function created() {
    this._isCollapseItem = true;
  },
  mounted: function mounted() {
    this.$on('open', this.$parent.openByIndex);
    if (this.isActived) {
      this.$emit('open', this.index);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.anime && this.targets) {
      __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.remove(this.targets);
    }
    this.$off('open', this.$parent.openByIndex);
  },


  computed: {
    index: function index() {
      return this.$parent.$collapseItems.indexOf(this);
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.isActived = !this.isActived) {
        this.$emit('open', this.index);
      }
    },
    getAnime: function getAnime(targets) {
      if (this.anime) return this.anime;
      return this.anime = __WEBPACK_IMPORTED_MODULE_0_animejs___default()({ targets: targets });
    },
    cancel: function cancel() {
      this.anime.pause();
    },
    before: function before(targets) {
      if (!this.targets) this.targets = targets;
      targets.removeAttribute('style');
    },
    enter: function enter(targets, done) {
      var height = targets.scrollHeight;
      targets.style.height = 0;
      targets.style.opacity = 0;
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [0, 1],
        height: height,
        complete: function complete() {
          targets.removeAttribute('style');
          done();
        }
      });
    },
    leave: function leave(targets, complete) {
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [1, 0],
        height: 0,
        complete: complete
      });
    }
  }
};

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

};

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(71);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },


  methods: {
    handleScroll: function handleScroll() {
      this.visible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* getScroll */])(window, true) > this.visibilityHeight;
    },
    scrollToTop: function scrollToTop() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(document.body, this.options);
    }
  }
};

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(17);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    target: String,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  created: function created() {
    this.$el = this.$el.nextSibling;
  },
  mounted: function mounted() {
    this.$el.addEventListener('click', this.handler);
  },


  methods: {
    handler: function handler() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(this.target, this.options);
    }
  }
};

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    type: String,
    size: String,
    value: {
      type: Number,
      required: true,
      default: 0
    },
    max: {
      type: Number,
      required: true,
      default: 0
    },
    showLabel: Boolean
  },

  computed: {
    percentage: function percentage() {
      return Math.floor(this.value / this.max * 100);
    }
  }

};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'nprogress-container'
};

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(118)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(104)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(119)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(120)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(117)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  "data-v-61c7b8a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(113)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(172),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(151),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ins', {
    staticClass: "adsbygoogle",
    style: (_vm.adStyle),
    attrs: {
      "data-ad-client": _vm.adClient,
      "data-ad-slot": _vm.adSlot,
      "data-ad-format": _vm.adFormat,
      "data-full-width-responsive": _vm.fullWidthResponse
    }
  })
},staticRenderFns: []}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor has-text-centered"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title "
  }, [_vm._v("File Upload")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.$upload.meta('file-upload').status === 'sending'
    },
    on: {
      "click": function($event) {
        _vm.$upload.select('file-upload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$upload.meta('file-upload').status === 'sending'),
      expression: "$upload.meta('file-upload').status === 'sending'"
    }]
  }, [_vm._v("Uploading...")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$upload.meta('file-upload').status != 'sending'),
      expression: "$upload.meta('file-upload').status != 'sending'"
    }]
  }, [_vm._v("Select")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.$upload.meta('file-upload').status === 'sending'
    },
    on: {
      "click": function($event) {
        _vm.$upload.reset('file-upload')
      }
    }
  }, [_vm._v("\n            Clear\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('progress-bar', {
    attrs: {
      "type": 'success',
      "value": _vm.$upload.meta('file-upload').percentComplete,
      "max": 100
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$upload.errors('file-upload').length) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.$upload.errors('file-upload')[0].message) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.$upload.files('file-upload').all.length) ? _c('div', [_vm._v("\n            No uploads here yet.\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.$upload.files('file-upload').progress), function(file) {
    return _c('div', [_c('div', [_vm._v("\n              " + _vm._s(file.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: ('width: ' + file.percentComplete + '%;')
    }, [_vm._v("\n                " + _vm._s(file.percentComplete) + "%\n              ")])])])
  }), _vm._v(" "), _vm._l((_vm.$upload.files('file-upload').queued), function(file) {
    return _c('div', [_c('div', [_vm._v("\n              " + _vm._s(file.name) + "\n              "), _c('br'), _vm._v("\n              Queued for upload\n            ")])])
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$upload.files('file-upload').complete), function(file) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(file.name) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(file.status) + "\n              ")]), _vm._v(" "), (file.status == 'success') ? _c('td', [_c('a', {
      staticClass: "short-link",
      attrs: {
        "href": file.downurl,
        "data-label": "Copied"
      }
    }, [_vm._v("https://flb.st/" + _vm._s(file.randname))])]) : _c('td'), _vm._v(" "), (file.status == 'success') ? _c('td', [_vm._v(" " + _vm._s(file.percentComplete) + "%")]) : _c('td', _vm._l((file.errors), function(filerror) {
      return _c('span', [_c('span', [_vm._v("  " + _vm._s(filerror.message) + " "), _c('br')])])
    }))])
  }))])], 2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Link")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-10 is-offset-3"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "WordSection1"
  }, [_c('h2', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\"",
      "color": "black"
    }
  }, [_vm._v("TERMS AND CONDITIONS"), _c('o:p')], 1)]), _vm._v(" "), _c('ol', {
    attrs: {
      "start": "1",
      "type": "1"
    }
  }, [_c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l10 level1 lfo1",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(0), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("These Website\nStandard Terms and Conditions written on this webpage shall manage your use of\nthis website. These Terms will be applied fully and affect to your use of this\nWebsite. By using this Website, you agreed to accept all terms and conditions\nwritten in here. You must not use this Website if you disagree with any of\nthese Website Standard Terms and Conditions."), _c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("Minors or people\nbelow 18 years old are not allowed to use this Website."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l4 level1 lfo2",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(1), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("Other than the\ncontent you own, under these Terms, "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v(" and/or\nits licensors own all the intellectual property rights and materials contained\nin this Website."), _c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("You are granted\nlimited license only for purposes of viewing the material contained on this\nWebsite."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l11 level1 lfo3",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(2), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("You are specifically\nrestricted from all of the following"), _c('o:p')], 1)]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "disc"
    }
  }, [_c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l6 level1 lfo4",
      "tab-stops": "list .5in"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("publishing\n     any Website material in any other media;"), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l6 level1 lfo4",
      "tab-stops": "list .5in"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("selling,\n     sublicensing and/or otherwise commercializing any Website material;"), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l6 level1 lfo4",
      "tab-stops": "list .5in"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("publicly\n     performing and/or showing any Website material;"), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l6 level1 lfo4",
      "tab-stops": "list .5in"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("using this\n     Website in any way that is or may be damaging to this Website;"), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l6 level1 lfo4",
      "tab-stops": "list .5in"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("using this\n     Website in any way that impacts user access to this Website;"), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l6 level1 lfo4",
      "tab-stops": "list .5in"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("using this\n     Website contrary to applicable laws and regulations, or in any way may\n     cause harm to the Website, or to any person or business entity;"), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l6 level1 lfo4",
      "tab-stops": "list .5in"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("engaging in\n     any data mining, data harvesting, data extracting or any other similar\n     activity in relation to this Website;"), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l6 level1 lfo4",
      "tab-stops": "list .5in"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("using this\n     Website to engage in any advertising or marketing."), _c('o:p')], 1)])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("Certain areas of\nthis Website are restricted from being access by you and "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v("\nmay further restrict access by you to any areas of this Website, at any time,\nin absolute discretion. Any user ID and password you may have for this Website\nare confidential and you must maintain confidentiality as well."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l8 level1 lfo5",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(3), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("In these Website\nStandard Terms and Conditions, “Your Content” shall mean any audio, video text,\nimages or other material you choose to display on this Website. By displaying\nYour Content, you grant "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v(" a non-exclusive,\nworldwide irrevocable, sub licensable license to use, reproduce, adapt,\npublish, translate and distribute it in any and all media."), _c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("Your Content must\nbe your own and must not be invading any third-party’s rights. "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v(" reserves the right to remove any of Your Content\nfrom this Website at any time without notice."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l1 level1 lfo6",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(4), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("This Website is\nprovided “as is,” with all faults, and "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v("\nexpress no representations or warranties, of any kind related to this Website\nor the materials contained on this Website. Also, nothing contained on this\nWebsite shall be interpreted as advising you."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l5 level1 lfo7",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(5), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("In no event shall "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v(", nor any of its officers, directors and\nemployees, shall be held liable for anything arising out of or in any way\nconnected with your use of this Website whether such liability is under contract.\n "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v(", including its officers, directors\nand employees shall not be held liable for any indirect, consequential or\nspecial liability arising out of or in any way related to your use of this\nWebsite."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l12 level1 lfo8",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(6), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("You hereby\nindemnify to the fullest extent "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v(" from and\nagainst any and/or all liabilities, costs, demands, causes of action, damages\nand expenses arising in any way related to your breach of any of the provisions\nof these Terms."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l7 level1 lfo9",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(7), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("If any provision of\nthese Terms is found to be invalid under any applicable law, such provisions\nshall be deleted without affecting the remaining provisions herein."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l2 level1 lfo10",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(8), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_vm._m(9), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v(" is permitted to revise\nthese Terms at any time as it sees fit, and by using this Website you are expected\nto review these Terms on a regular basis."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l9 level1 lfo11",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(10), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("The "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v(" is allowed to assign, transfer, and subcontract\nits rights and/or obligations under these Terms without any notification.\nHowever, you are not allowed to assign, transfer, or subcontract any of your\nrights and/or obligations under these Terms."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l0 level1 lfo12",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(11), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("These Terms\nconstitute the entire agreement between "), _c('span', {
    staticClass: "SpellE"
  }, [_vm._v("FilesBeast")]), _vm._v("\nand you in relation to your use of this Website, and supersede all prior\nagreements and understandings."), _c('o:p')], 1)]), _vm._v(" "), _c('li', {
    staticClass: "MsoNormal",
    staticStyle: {
      "color": "black",
      "mso-margin-top-alt": "auto",
      "mso-list": "l3 level1 lfo13",
      "tab-stops": "list .5in"
    }
  }, [_vm._m(12), _c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("These Terms will be\ngoverned by and interpreted in accordance with the laws of the State of\nIslamabad, Pakistan, and you submit to the non-exclusive jurisdiction of the\nstate and federal courts located in Islamabad, Pakistan for the resolution of\nany disputes."), _c('o:p')], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Introduction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Intellectual\n     Property Rights")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Restrictions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Your\n     Content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("No\n     warranties")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Limitation\n     of liability")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Indemnification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Severability")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Variation\n     of Terms")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "SpellE"
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("FilesBeast")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Assignment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Entire\n     Agreement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial\",sans-serif",
      "mso-fareast-font-family": "\"Times New Roman\""
    }
  }, [_vm._v("Governing\n     Law & Jurisdiction")])])
}]}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('tooltip', [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": "/assets/img/logo.png"
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/shorturl"
    }
  }, [_vm._v("URL Shortner")]), _vm._v(" "), (_vm.$auth.check()) ? _c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]) : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), (_vm.$auth.check()) ? _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }) : _vm._e(), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-10 is-offset-3"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "block is-flex",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.shortenURL($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "input urlinput",
    attrs: {
      "type": "text",
      "placeholder": "Your original URL here"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Submit URL")])]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.shorturls), function(url) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": url.original,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(url.original))])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "short-link",
      attrs: {
        "href": url.short,
        "target": "_blank",
        "data-label": "Copied"
      }
    }, [_vm._v("\n              " + _vm._s(url.short) + "\n            ")])])])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-compress"
  }), _vm._v(" Shorten your links")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Original URL")]), _vm._v(" "), _c('th', [_vm._v("Short URL")])])])
}]}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title "
  }, [_vm._v("My Files")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadedfiles), function(file) {
    return _c('tr', {
      attrs: {
        "id": file.randname
      }
    }, [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(file.created_on))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-danger is-outlined",
      style: ('font-size:.8rem;'),
      on: {
        "click": function($event) {
          _vm.deleteFile(file.randname)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-trash"
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-danger is-outlined",
      style: ('font-size:.8rem;'),
      on: {
        "click": function($event) {
          _vm.navigateTo('/edit/' + file.randname)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-pencil"
    })])])])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Uploaded On")]), _vm._v(" "), _c('th', [_vm._v("Download Link")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card collapse-item",
    class: {
      'is-fullwidth': _vm.$parent.isFullwidth, 'is-active': _vm.isActived
    }
  }, [_c('header', {
    staticClass: "card-header touchable",
    attrs: {
      "role": "tab",
      "aria-expanded": _vm.selected ? 'true' : 'fase'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('h3', {
    staticClass: "card-header-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapsed-fade",
      "css": false,
      "appear": ""
    },
    on: {
      "before-appear": _vm.before,
      "appear": _vm.enter,
      "appear-cancel": _vm.cancel,
      "before-enter": _vm.before,
      "enter": _vm.enter,
      "enter-cancel": _vm.cancel,
      "leave": _vm.leave,
      "leave-cancel": _vm.cancel
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActived),
      expression: "isActived"
    }],
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-content-box"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-header-icon"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title "
  }, [_vm._v("Users")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', {
      attrs: {
        "id": user.uid
      }
    }, [_c('td', [_vm._v(_vm._s(user.uid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.role))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-danger is-outlined",
      style: ('font-size:.8rem;'),
      on: {
        "click": function($event) {
          _vm.deleteUser(user.uid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-trash"
    })])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.adduser($event)
      }
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Add User")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.email),
      expression: "data.body.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.data.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.body.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "username",
      "value": "username"
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.body.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.body.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Submit")])])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-top"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-5 is-offset-custom-home-desktop"
  }, [_c('article', {
    staticClass: "tile is-child box bottom-padding-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadedfiles), function(file) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("formatNumber")(file.downloads)))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))])]), _vm._v(" "), _c('ul', {
    staticClass: "pagination-list"
  }, [(_vm.next > 0) ? _c('li', {
    staticClass: "pagination-next",
    on: {
      "click": function($event) {
        _vm.next -= 1;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  })]) : _vm._e(), _vm._v(" "), _vm._l(((Math.ceil(_vm.pagetop / 10))), function(n) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (n <= (_vm.next + 1) * 5 && n > _vm.next * 5),
        expression: "n<=(next+1)*5 && n>next*5"
      }],
      staticClass: "pagination-next ",
      on: {
        "click": function($event) {
          _vm.fetchPage(n, $event)
        }
      }
    }, [_vm._v(_vm._s(n) + "\n          ")])
  }), _vm._v(" "), ((_vm.next + 1) * 5 < Math.ceil(_vm.pagetop / 10)) ? _c('li', {
    staticClass: "pagination-next",
    on: {
      "click": function($event) {
        _vm.next += 1;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right"
  })]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-5"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.popularfiles), function(file) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("formatNumber")(file.downloads)))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-10 is-offset-custom-home-desktop"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        _vm.searchFiles()
      }]
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-primary"
  }, [_vm._v(" Search")])]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('table', {
    staticClass: "table is-striped is-narrow "
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.searchedfiles), function(file) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(file.downloads))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" Uploads")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("DLs")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" Popular Uploads")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("DLs")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" File Search")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', {
    staticClass: "no-break-word"
  }, [_vm._v("DLs")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.adduser($event)
      }
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Edit File Info")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.file.name),
      expression: "file.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "name",
      "placeholder": "filename"
    },
    domProps: {
      "value": (_vm.file.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.file.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.file.tags),
      expression: "file.tags"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "seo tags",
      "value": "tags"
    },
    domProps: {
      "value": (_vm.file.tags)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.file.tags = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.updateFileInfo
    }
  }, [_vm._v("Submit")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "jump back-to-top",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-10 is-offset-3"
  }, [_c('article', {
    staticClass: "tile is-child box "
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("DMCA & Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v("\n        Files uploaded on FilesBeast.net are available at different online sources. The files are believed to be available under public domain. Content posted on our site is supposed to be posted while abiding by our rights according to the Fair Use Act (Title 17, U.S. Code). If a file or any other piece of content posted on our site is violating your copyright, then you can immediately send us an email at "), _c('a', {
    attrs: {
      "href": "mailto:copyright@filesbeast.net"
    }
  }, [_vm._v("copyright@filesbeast.net")]), _vm._v("\n        or use our contact us page. We will act promptly to get the violating content removed from our site.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-centered "
  }, [_vm._v("Notification of Copyright Infringement")]), _vm._v(" "), _c('h3', {
    staticClass: "is-bold justified"
  }, [_vm._v("Digital Millennium Copyright Act")]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v("\n        FilesBeast.net is an Online Service Provider under the Title II of the Digital Millennium Copyright Act, 17 U.S.C. Section 512 (“DMCA”). FilesBeast.net duly respects the copyright owners and urges its users and viewers to do the same. FilesBest.net follows the standards set and required by DMCA to apply and take an action against any kind of take down notice. The policy here is intended to help the copyright owners to utilize the DMCA procedure and also help the users to get the access back to the content removed mistakenly.")]), _vm._v(" "), _c('h3', {
    staticClass: "justified is-bold"
  }, [_vm._v(" Notice to Owners of Copyrighted Works")]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v("\n        If you find any content on FilesBeast.net violating your copyrights, being the owner of the content or authorized to act on behalf of owner, we urge you to report the infringements by completing the following notice and intimating about it to FilesBeast.net’s Designated Copyright Agent.")]), _vm._v(" "), _c('h3', {
    staticClass: "justified is-bold"
  }, [_vm._v("DMCA Notice of Alleged Infringement")]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v("\n        To file a notice of infringing material on FilesBeast.net, please provide a notification containing the following details:\n      "), _c('ol', {
    staticClass: "list",
    attrs: {
      "start": "1"
    }
  }, [_c('li', [_vm._v("\n          A physical signature of a developer or development team authorized to act on behalf of the owner of an exclusive right that is allegedly infringed. It's necessary for third party agencies to provide a copy of \"Physical Authorization Letter\" that agency can address all the copyrights things of them.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single online site are covered by a single notification, a representative list of such works at that site.\n        ")]), _vm._v(" "), _c('li', [_vm._v("Providing URLs in the body of an email is the best way to help us locate content quickly.")]), _vm._v(" "), _c('li', [_vm._v("\n          Information reasonably sufficient to permit the service provider to contact the complaining party, such as an address, telephone number, and, if available, an electronic mail address at which the complaining party may be contacted.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          A statement that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          A statement that the information in the notification is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed (Note that under Section 512(f) any person who knowingly and materially misrepresents that material or activity is infringing may be subject to liability for damages.\n        ")])])]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v("When filing an infringement claim, please include any URLs identifying the allegedly infringing material along with any other information that might assist the FilesBeast.net Agent’s investigation of your claim.\n        If the material originates from another website and you believe that FilesBeast.net has cached that material, then confirm any of the following that apply:")]), _vm._v(" "), _c('ul', {
    staticClass: "list",
    attrs: {
      "type": "round"
    }
  }, [_c('li', [_vm._v("The material has been removed from the originating site;")]), _vm._v(" "), _c('li', [_vm._v("access to the material on the originating site has been disabled;")]), _vm._v(" "), _c('li', [_vm._v("a court has ordered that the material be removed from the originating site; and/or")]), _vm._v(" "), _c('li', [_vm._v("a court has ordered that access to the material on the originating site be disabled.")])]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v("Failure to include all of the above information may result in a delay in processing the DMCA Notification.")]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v("If you materially misrepresent that any material infringes your copyright interest, you may be liable for damages, including court costs and attorneys’ fees, and could be subject to criminal prosecution for perjury.")]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v("To expedite our ability to process your request, such written notice should be sent to the following FilesBeast.net’s Designated Copyright Agent email address:")]), _vm._v(" "), _c('h2', {
    staticClass: "is-bold has-text-centered"
  }, [_vm._v("Usama Mujtaba")]), _vm._v(" "), _c('h3', {
    staticClass: "is-bold has-text-centered"
  }, [_vm._v("usamam [at] filesbeast [dot] net")]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v(" You may also write to us using the Contact Us page.")]), _vm._v(" "), _c('p', {
    staticClass: "justified"
  }, [_vm._v(" Upon receipt of a valid claim, FilesBeast.net will follow the procedures provided in the DMCA which prescribe a notice and take down procedure, subject to the user’s or webmaster’s right to submit a Counter-Notification claiming lawful use of the disabled works. FilesBeast.net will have the disputed material removed from public view and access. FilesBeast.net will also notify the user or webmaster who posted the allegedly infringing material that has been removed or disable access to that material.")])])])])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, [_c('div', {
    staticClass: "column is-full-mobile is-6-desktop "
  }, [_c('vue-adsense', {
    attrs: {
      "ad-style": "display:block",
      "ad-client": "ca-pub-8717113253404092",
      "ad-slot": "7401582331",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('base-card', {
    attrs: {
      "title": _vm.capstitle,
      "content": _vm.getDescription(_vm.file)
    }
  }, [(_vm.file.userid) ? _c('card-footer-item', {
    staticClass: "short-link",
    attrs: {
      "href": 'https://flb.st/' + _vm.$route.params.fileid,
      "data-label": "Copied"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copyUrl($event)
      }
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-share-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("  \n        Short Link\n      ")]) : _vm._e(), _vm._v(" "), (_vm.file.userid) ? _c('card-footer-item', {
    attrs: {
      "href": '/download/' + _vm.file.userid + '/' + _vm.file.name
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("  \n        Download\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('vue-adsense', {
    attrs: {
      "ad-style": "display:block",
      "ad-client": "ca-pub-8717113253404092",
      "ad-slot": "7401582331",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-full-mobile is-4-desktop is-offset-sidebar-desktop"
  }, [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Popular Uploads")]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.popularfiles), function(file) {
    return _c('collapse-item', {
      key: file.randname,
      attrs: {
        "title": _vm._f("capitalize")(file.name)
      }
    }, [_c('div', {
      staticClass: "is-inline-block"
    }, [_c('strong', [_vm._v("Size")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "filedata"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))])]), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block"
    }, [_c('strong', [_vm._v("Downloads")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "filedata"
    }, [_vm._v(_vm._s(_vm._f("formatNumber")(file.downloads)))])]), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block"
    }, [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "adcode2"
  }, [_c('span', [_c('vue-adsense', {
    attrs: {
      "ad-style": "display:block",
      "ad-client": "ca-pub-8717113253404092",
      "ad-slot": "6696673629",
      "ad-format": "auto"
    }
  })], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Recent Uploads")]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.recentfiles), function(file) {
    return _c('collapse-item', {
      key: file.randname,
      attrs: {
        "title": _vm._f("capitalize")(file.name)
      }
    }, [_c('div', {
      staticClass: "is-inline-block"
    }, [_c('strong', [_vm._v("Size")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "filedata"
    }, [_vm._v(_vm._s(_vm._f("prettyBytes")(file.size)))])]), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block"
    }, [_c('strong', [_vm._v("Downloads")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "filedata"
    }, [_vm._v(_vm._s(_vm._f("formatNumber")(file.downloads)))])]), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block"
    }, [_c('a', {
      attrs: {
        "href": '/file/' + file.randname
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-cloud-download",
      style: ('margin-left:18%;')
    })])])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 is-offset-3"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.error) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error.msg))]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "username",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.body.username = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.body.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])
}]}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse is-fullwidth"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "footer"
  }, [_c('footer', [_c('a', {
    staticClass: "footer-href",
    attrs: {
      "href": "/dmca"
    }
  }, [_vm._v("DMCA & Copyright")]), _c('a', {
    staticClass: "footer-href",
    attrs: {
      "href": "/toc"
    }
  }, [_vm._v("Terms & Conditions")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n      All the files uploaded on FilesBeast.net are free to use and distribute. FilesBeast.net does not own any of the files uploaded. The uploaded files belong to their rightful owners.\n\n      "), _c('br'), _c('br'), _vm._v("© 2017 FilesBeast.net. All rights reserved.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar-right animated"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('collapse', [_c('collapse-item', {
    attrs: {
      "title": "Components"
    }
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css\n            #responsive\n          ")]), _vm._v(" "), _c('collapse-item', {
    attrs: {
      "title": "Elements"
    }
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css\n            #responsive\n          ")]), _vm._v(" "), _c('collapse-item', {
    attrs: {
      "title": "Nests"
    }
  }, [_c('collapse', [_c('collapse-item', {
    attrs: {
      "title": "Nest Child"
    }
  }, [_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris. @bulmaio. #css\n                #responsive\n              ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    staticClass: "card is-fullwidth"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), (!!this.icon) ? _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa",
    class: [("fa-" + _vm.icon)]
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])]), _vm._v(" "), (!!this.$slots.footer) ? _c('footer', {
    staticClass: "card-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    General\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return (_vm.checkAuth(item.meta)) ? _c('li', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v("\n              " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n            ")])], 1) : _vm._e()
    }))]) : _vm._e()], 1) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-container is-flex"
  }, [_c('progress', {
    class: ['progress', _vm.type ? ("is-" + _vm.type) : '', _vm.size ? ("is-" + _vm.size) : ''],
    attrs: {
      "value": _vm.value,
      "max": _vm.max
    }
  }), _vm._v(" "), (_vm.showLabel) ? _c('span', [_vm._v(_vm._s(_vm.percentage + '%'))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  })])])])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jump"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-admin","version":"0.1.12","description":"Vue Admin Panel Framework","repository":"vue-bulma/vue-admin","homepage":"https://admin.vuebulma.com","license":"MIT","author":{"name":"Fangdun Cai","email":"cfddream@gmail.com","url":"fundon.me"},"keywords":["admin","bulma","dashboard","data","visualization","vue"],"engines":{"node":">=4","npm":">=3"},"scripts":{"build":"cross-env NODE_ENV=production node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","gh":"npm run build && gh-pages -d dist","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol"},"dependencies":{"@websanova/vue-auth":"^2.8.2-beta","@websanova/vue-upload":"^0.2.10-beta","animate.css":"3.5.2","animejs":"^2.0.1","axios":"^0.15.3","bulma":"^0.3.2","font-awesome":"4.7.0","mdi":"^1.8.36","numeral":"^2.0.6","plotly.js":"^1.24.2","vue":"2.2.2","vue-axios":"2.0.1","vue-bulma-brace":"0.1.0","vue-bulma-breadcrumb":"1.0.1","vue-bulma-card":"1.0.2","vue-bulma-chartist":"1.1.0","vue-bulma-chartjs":"1.0.4","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"1.3.0","vue-bulma-emoji":"0.0.2","vue-bulma-expanding":"0.0.1","vue-bulma-jump":"0.0.2","vue-bulma-message":"1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-notification":"1.1.1","vue-bulma-progress-bar":"1.0.2","vue-bulma-progress-tracker":"0.0.4","vue-bulma-quill":"0.0.1","vue-bulma-rating":"1.0.1","vue-bulma-slider":"1.0.2","vue-bulma-switch":"1.0.4","vue-bulma-tabs":"1.1.2","vue-bulma-tooltip":"1.0.3","vue-cleave":"1.1.1","vue-content-placeholder":"1.0.5","vue-lory":"0.0.4","vue-meta":"1.4.0","vue-msg-bag":"0.4.0","vue-nprogress":"0.1.5","vue-peity":"0.5.0","vue-resource":"1.3.4","vue-router":"2.3.0","vuejs-paginator":"2.0.2","vuex":"2.2.1","vuex-router-sync":"4.1.2","wysiwyg.css":"0.0.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.21.0","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-transform-export-extensions":"^6.8.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.17.0","connect-history-api-fallback":"^1.3.0","cross-env":"^3.1.3","css-loader":"^0.27.1","electron-devtools-installer":"^2.0.1","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^2.0.0-beta.4","file-loader":"^0.10.1","html-webpack-plugin":"^2.25.0","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.1.1","opn":"^4.0.2","ora":"^1.1.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.9.1","sass-loader":"^6.0.3","serve-favicon":"^2.4.1","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-adsense":"git+ssh://git@github.com/darrynten/vue-adsense.git","vue-html-loader":"1.2.3","vue-loader":"11.1.4","vue-template-compiler":"2.2.2","webpack":"^2.2.1","webpack-dev-middleware":"^1.9.0","webpack-hot-middleware":"^2.14.0","webpack-merge":"^4.0.0"}}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(29);


/***/ })
],[178]);


// WEBPACK FOOTER //
// assets/js/app.1cbc14b4920e3817a419.js